var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_72",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 13.2308C6.65517 13.2308 6.36383 13.1118 6.126 12.874C5.88817 12.6362 5.76925 12.3448 5.76925 12C5.76925 11.6552 5.88817 11.3638 6.126 11.126C6.36383 10.8882 6.65517 10.7693 7 10.7693C7.34483 10.7693 7.63617 10.8882 7.874 11.126C8.11183 11.3638 8.23075 11.6552 8.23075 12C8.23075 12.3448 8.11183 12.6362 7.874 12.874C7.63617 13.1118 7.34483 13.2308 7 13.2308ZM7 17C5.61533 17 4.43583 16.5128 3.4615 15.5385C2.48717 14.5642 2 13.3847 2 12C2 10.6153 2.48717 9.43583 3.4615 8.4615C4.43583 7.48717 5.61533 7 7 7C8.027 7 8.953 7.27817 9.778 7.8345C10.603 8.391 11.2052 9.11283 11.5845 10H20.7885L22.7885 12L19.5963 15.1538L17.8845 13.8655L16.077 15.1923L14.298 14H11.5845C11.2052 14.8743 10.603 15.5929 9.778 16.1558C8.953 16.7186 8.027 17 7 17ZM7 16C7.98467 16 8.82475 15.7038 9.52025 15.1115C10.2157 14.5192 10.6609 13.8153 10.8558 13H14.6155L16.0462 13.9673L17.9038 12.6345L19.525 13.8558L21.3808 12L20.3808 11H10.8558C10.6609 10.1847 10.2157 9.48083 9.52025 8.8885C8.82475 8.29617 7.98467 8 7 8C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.1fc5c26c44a84c6073f700aede54e31d.svg";
export { ForwardRef as ReactComponent };